<template>
  <div class="modal error-modal">
    <div class="overlay" @click="$parent.closeErrorModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              @click="$parent.closeErrorModal"
              src="./../images/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title dark">ERROR</div>
                <div class="error-message desc dark">
                  {{ $parent.errorModalMessage }}
                </div>
                <button class="button" @click="$parent.closeErrorModal">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorModal",
};
</script>

<style scoped lang="scss">
.error-modal {
  .close {
    filter: brightness(0) invert(1);
  }

  .wrapper {
    max-width: 480px;
  }

  .form-fields-wrapper {
    max-width: 400px;
    margin: 0 auto;
    padding-bottom: 12px;
    text-align: center;
  }

  .error-message {
    margin-top: 16px;
  }

  .button {
    margin: 28px auto 0;
    max-width: 200px;
  }
}

@media screen and (max-width: 768px) {
  .error-modal .wrapper {
    max-width: 100%;
  }

  .error-modal .container {
    padding: 24px 16px;
  }
}
</style>

